<template>
    <div id="card">
        <div id="chart">
            <apexchart :type="chartType" :height="chartHeight" :options="chartOptions" :series="series"></apexchart>
        </div>
    </div>
</template>
<script>
import VueApexCharts from "vue3-apexcharts";
export default {
    props : {
        chartData : {
            type : Object,
            default : () => ({ labels: [], datasets: [] })
        },
        chartType : {
          type : String,
          default : 'pie'
        },
        chartHeight : {
          type : [Number, String],
          default : 250
        }
    },
    components: {
        apexchart : VueApexCharts,
    },
    computed: {
        series() {
            return this.chartData.datasets || [];
        },
        chartOptions() {
            return {
                chart: {
                    width: '100%',
                    type: this.chartType,
                },
                labels: this.chartData.labels || [],
                responsive: [{
                    breakpoint: 480,
                    options: {
                        chart: {
                            width: 200
                        }
                    }
                }],
                legend: { position: 'bottom' },
                colors: ['#f7b924', '#17c1e8', '#82d616', '#cb0c9f', '#344767']
            };
        }
    }
};
</script>